import React from 'react';
import PropTypes from 'prop-types';

import {Box, TextField, Paper, Stack, Typography} from 'views/components';
import {Check} from 'views/icons';
import {translate, Translate} from 'views/module';

import {IMPROVEMENT_OPTIONS} from '../../../utils/constants';

const ImprovementCard = (props) => {
  const {
    improvementTopicResponses,
    setImprovementTopicResponses,
    additionalComments,
    setAdditionalComments,
  } = props;

  const handleClick = (isSelected, topic) => {
    if (isSelected) {
      setImprovementTopicResponses(improvementTopicResponses.filter((topicResponse) => topicResponse !== topic));
    } else {
      setImprovementTopicResponses([...improvementTopicResponses, topic]);
    }
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: '12px',
        p: 3,
      }}
    >
      <Typography
        sx={{
          fontSize: '1.2rem',
          fontWeight: 600,
        }}
      >
        <Translate expression='eventFeedback.CanWeImprove.Title'/>
      </Typography>
      {/* Improvment Topic Options */}
      <Stack
        spacing={1}
        sx={{
          mt: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: '0.85rem',
          }}
        >
          <Translate expression='eventFeedback.CanWeImprove.RelevantTopicsSubtitle'/>
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'left',
            flexWrap: 'wrap',
            gap: 1,
          }}
        >
          {
            IMPROVEMENT_OPTIONS.map((topic) => {
              const isSelected = improvementTopicResponses.includes(topic.value);
              return (
                <Stack
                  key={topic.value}
                  direction="row"
                  alignItems="center"
                  onClick={() => handleClick(isSelected, topic.value)}
                  tabIndex={0} // makes the focus styles work
                  sx={{
                    'cursor': 'pointer',
                    'px': 1.5,
                    'py': 1,
                    'borderStyle': 'solid',
                    'borderRadius': '9999px',
                    'borderColor': '#dfdfdf',
                    'borderWidth': '1.5px',
                    'backgroundColor': isSelected ? '#10a4a0' : 'color.white',
                    '&:hover': {
                      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                      transform: 'scale(1.05)',
                      borderColor: '#10a4a0',
                      bgcolor: isSelected ? '#10a4a0' : 'color.white',
                    },
                    '&:focus': {
                      outline: 'none',
                      boxShadow: '0 0 0 4px #10a4a033',
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '0.85rem',
                      color: isSelected ? 'color.white' : 'color.black',
                      fontWeight: isSelected ? 500 : 400,
                    }}
                  >
                    <Translate expression={topic.translationKey}/>
                  </Typography>
                  {
                    isSelected &&
                    <Check
                      fontSize='small'
                      sx={{
                        ml: 1,
                        color: 'color.white',
                        display: 'inline-flex',
                      }}
                    />
                  }
                </Stack>
              );
            })
          }
        </Box>
      </Stack>
      {/* Additional Comments */}
      <Stack
        spacing={1}
        sx={{
          mt: 2,
        }}
      >
        <Typography>
          <Translate expression='eventFeedback.CanWeImprove.AdditionalCommentsSubtitle'/>
        </Typography>
        <TextField
          value={additionalComments}
          variant="outlined"
          onChange={(newValue) => setAdditionalComments(newValue)}
          placeholder={translate('eventFeedback.CanWeImprove.AdditionalCommentsPlaceholder')}
          rows={4}
          multiline
          fullWidth
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderWidth: '1.5px',
            },
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#10a4a0',
            },
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#10a4a0',
            },
            '& .MuiOutlinedInput-root.Mui-focused': {
              boxShadow: '0 0 0 4px #10a4a033',
            },
          }}
        />
      </Stack>
    </Paper>
  );
};

ImprovementCard.propTypes = {
  improvementTopicResponses: PropTypes.array.isRequired,
  setImprovementTopicResponses: PropTypes.func.isRequired,
  additionalComments: PropTypes.string.isRequired,
  setAdditionalComments: PropTypes.func.isRequired,
};

export default React.memo(ImprovementCard);
